<template>
  <div class="gaojing">
    <el-card class="box-card cards">
        <div class="text item">
            在场人数:{{pepopleCount}}
        </div>
        <div class="text item">
            摄像头数量:{{2}}
        </div>
        <div class="text item">区域总数:{{area_Count}}
        </div>
        <div class="text item">低风险区域:{{dArea_Count}}
        </div>
        <div class="text item">一般风险区域:{{ybArea_Count}}
        </div>
        <div class="text item">较大风险区域:{{jdArea_Count}}
        </div>
        <div class="text item">重大风险区域:{{zdArea_Count}}
        </div>
    </el-card>
  </div>
</template>

<script>
import {getResultCount} from "@/api/BoxData.js"
import {getWarn} from "@/api/worker.js"
import D3Config from '@/utils/D3Config'
import {mapMutations, mapGetters} from "vuex"
export default {
  name: 'Gaojing',
   data() {
    return {
        drawer: true,
        direction: 'rtl'
    };
  },

  props: {
    msg: String
  },
  computed:{
      ...mapGetters([
          'pepopleCount',
          'area_Count',
          'dArea_Count',
          'ybArea_Count',
          'jdArea_Count',
          'zdArea_Count',
      ])
  },
  methods:{
      ...mapMutations([
        'setarea_Count',
        'setdArea_Count',//低风险区域数量
        'setybArea_Count',//一般风险区域数量
        'setjdArea_Count',//较大风险区域数量
        'setzdArea_Count'
      ])
  },
  mounted(){
    
    getResultCount().then((res)=>{
      let counts=res.data.data
      this.setzdArea_Count(counts[0].count)
      this.setjdArea_Count(counts[1].count)
      this.setybArea_Count(counts[2].count)
      this.setdArea_Count(counts[3].count)
      this.setarea_Count(counts[3].count+counts[2].count+counts[1].count+counts[0].count)
    })
  }

}
</script>

<style scoped>

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}
.gaojing{
    width: 240px;
    position: absolute;
    top: 10px;
    left: 10px;
}
.cards{
  background: #0d254a;
  color: #e7e8ea;
}
</style>